import { forwardRef } from "react";

const smartFieldStyle = {
  userSelect: 'none',
  backgroundColor: '#f3f3f3',
  border: '1px solid #ccc',
  padding: '2px 4px',
  borderRadius: '4px',
  display: 'inline-block'
};

const Footer = forwardRef(({ }, ref) => {

  return (
    <div ref={ref}
      id="footer"
      style={{
        height: "170px",
      }}
    >
      <div style={{marginBottom: "20px"}}>Fait en deux examplaires, à  <span data-smartfield="[locationAndDate/]" contentEditable={false} style={smartFieldStyle}>Lieu + Date</span></div>
      <div style={{
        display: "flex",
        flexDirection: "row",
        width: "100%"
      }}>
        <div
          style={{
            width: "50%"
          }}>
          <div>Pour l'entreprise</div>
          <div><span data-smartfield="[businessOwner/]" contentEditable={false} style={smartFieldStyle}>Directeur Entreprise</span></div>
          <div>Cachet obligatoire</div>
          <div style={{marginBottom: "150px"}}><span data-smartfield="[sc_sign2.signature/]" contentEditable={false} style={smartFieldStyle}>Signature Entreprise</span></div>
        </div>
        <div
          style={{
            width: "50%"
          }}>
          <div>Pour le CFA</div>
          <div><span data-smartfield="[cfaOwner/]" contentEditable={false} style={smartFieldStyle}>Directeur CFA</span></div>
          <div>Cachet obligatoire</div>
          <div style={{marginBottom: "150px"}}><span data-smartfield="[sc_sign1.signature/]" contentEditable={false} style={smartFieldStyle}>Signature CFA</span></div>
        </div>
      </div>
    </div>
  );
});

export default Footer;